import RequestBalance from './RequestBalanceContainer.vue';

export { RequestBalance };



// WEBPACK FOOTER //
// ./src/modules/home/requestBalance/index.js